import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=56abac68"
import script from "./ModalComponent.vue?vue&type=script&lang=ts"
export * from "./ModalComponent.vue?vue&type=script&lang=ts"
import style0 from "./ModalComponent.vue?vue&type=style&index=0&id=56abac68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports